<script lang="ts">

    export let title: string = undefined;

</script>

<div class="title-bar">
    <h4>{title}</h4>
    <div class="buttons">
        <slot />
    </div>
</div>

<style lang="scss">

    .title-bar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1rem;
        min-height: 40px;
    }

    h4 {
        margin-bottom: 0;
    }

</style>